import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/Icons/chevron-up-solid.svg'
import _imports_1 from '@/assets/img/Icons/chevron-down-solid.svg'


const _withScopeId = n => (_pushScopeId("data-v-530d2c12"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "topic-group" }
const _hoisted_2 = { style: {"display":"flex","justify-content":"space-between","gap":"6px"} }
const _hoisted_3 = { class: "nps-bar" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nb-bar nb-background" }, null, -1))
const _hoisted_5 = { class: "goal" }
const _hoisted_6 = { class: "number-part" }
const _hoisted_7 = { style: {"display":"flex","justify-content":"flex-end"} }
const _hoisted_8 = { class: "nps-number" }
const _hoisted_9 = {
  key: 0,
  src: _imports_0,
  style: {"transform":"translateY(-2px)"}
}
const _hoisted_10 = {
  key: 1,
  src: _imports_1,
  class: "error-red"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FontAwesomeIcon = _resolveComponent("FontAwesomeIcon")!
  const _component_Typography = _resolveComponent("Typography")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_FontAwesomeIcon, {
        icon: _ctx.faArrowCircleRight,
        size: "xs",
        class: "group-arrow-icon"
      }, null, 8, ["icon"]),
      _createVNode(_component_Typography, {
        variant: "subtitle2",
        class: "group-text"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.group), 1)
        ], undefined, true),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", {
          class: "nb-bar nb-nps",
          style: _normalizeStyle({
                        left: _ctx.deltaPositionRelative + '%',
                        width: _ctx.deltaWidthPercent + '%',
                        background: _ctx.npsColor,
                        opacity: 0.9,
                        borderRadius: _ctx.borderRadius,
                    })
        }, null, 4),
        (_ctx.showGoal)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "goal-container",
              style: _normalizeStyle({ left: _ctx.middlePercent + '%' })
            }, [
              _createElementVNode("div", _hoisted_5, [
                _createVNode(_component_Typography, {
                  variant: "caption",
                  class: "goal-text"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Goal " + _toDisplayString(_ctx.goalFormatted), 1)
                  ], undefined, true),
                  _: 1
                })
              ])
            ], 4))
          : _createCommentVNode("", true),
        _createElementVNode("div", {
          class: "nb-average",
          style: _normalizeStyle({ left: _ctx.middlePercent + '%' })
        }, null, 4)
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_Typography, {
          variant: "subtitle2",
          class: _normalizeClass([_ctx.nps < _ctx.goal ? 'warning-orange' : 'success-green'])
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.formatScore(
                                _ctx.nps,
                                _ctx.isFiveScoreQuestionType(_ctx.scoreType),
                                _ctx.$companyVars.has_display_csat_as_percentage,
                                _ctx.scoreType,
                                _ctx.$companyVars?.decimals
                            )), 1),
              (_ctx.nps >= _ctx.previousNps)
                ? (_openBlock(), _createElementBlock("img", _hoisted_9))
                : (_openBlock(), _createElementBlock("img", _hoisted_10))
            ])
          ], undefined, true),
          _: 1
        }, 8, ["class"])
      ])
    ])
  ]))
}